import { Link } from "react-router-dom";
import { Shield, Globe } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export function ModernFooter() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-[#E2E8F0] bg-[#F8FAFC] dark:border-[#244585] dark:bg-[#061128]" aria-label="Pied de page" data-marketing-footer>
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <div className="flex flex-col">
                <img src="/LogoSmall.png" alt="LYRRA Studio" className="h-7 dark:hidden" />
                <img src="/LogoLightSmall.png" alt="LYRRA Studio" className="hidden h-7 dark:block" />
              </div>
            </div>
            <p className="text-sm leading-relaxed text-[#475569] dark:text-slate-300">
              {t('publicFooter.description')}
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="mb-6 font-semibold text-[#0F172A] dark:text-white">{t('publicFooter.product.title')}</h3>
            <ul className="space-y-3">
              <li><Link to="/pricing" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.product.pricing')}</Link></li>
              <li><Link to="/dashboard" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.product.dashboard')}</Link></li>
              <li><Link to="/aide" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.product.help')}</Link></li>
            </ul>
          </div>

          {/* Entreprise */}
          <div>
            <h3 className="mb-6 font-semibold text-[#0F172A] dark:text-white">{t('publicFooter.company.title')}</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.company.about')}</Link></li>
              <li><Link to="/contact" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.company.contact')}</Link></li>
              <li><Link to="/partners" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.company.partners')}</Link></li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h3 className="mb-6 font-semibold text-[#0F172A] dark:text-white">{t('publicFooter.legal.title')}</h3>
            <ul className="space-y-3">
              <li><Link to="/privacy" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.legal.privacy')}</Link></li>
              <li><Link to="/terms" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.legal.terms')}</Link></li>
              <li><Link to="/cookies" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white transition-colors">{t('publicFooter.legal.cookies')}</Link></li>
            </ul>
          </div>
        </div>

        {/* Logo French Tech */}
        <div className="hidden lg:flex justify-end mt-8">
          <img src="/FT_logo240.png" alt="La French Tech" className="w-28 h-auto object-contain opacity-70" />
        </div>

        {/* Bottom Footer */}
        <div className="mt-6 border-t border-[#E2E8F0] pt-8 dark:border-[#244585]">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
            <div className="mb-2 flex flex-col gap-3 text-center sm:flex-row sm:items-center sm:gap-6 lg:mb-0 sm:text-start">
              <p className="text-sm text-[#475569] dark:text-slate-300">{t('publicFooter.copyright')}</p>
              <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-4 gap-y-2">
                <Link to="/privacy" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white text-sm transition-colors">{t('publicFooter.legal.privacy')}</Link>
                <Link to="/terms" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white text-sm transition-colors">{t('publicFooter.legal.terms')}</Link>
                <Link to="/cookies" className="text-[#475569] hover:text-[#1D4ED8] dark:text-slate-300 dark:hover:text-white text-sm transition-colors">{t('publicFooter.legal.cookies')}</Link>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <div className="flex items-center gap-2">
                <Shield className="w-4 h-4 text-[#10B981]" aria-hidden="true" />
                <span className="text-sm text-[#475569] dark:text-slate-300">{t('publicFooter.security.ssl')}</span>
              </div>
              <div className="flex items-center gap-2">
                <Globe className="w-4 h-4 text-[#1D4ED8]" aria-hidden="true" />
                <span className="text-sm text-[#475569] dark:text-slate-300">{t('publicFooter.security.gdpr')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
